export const hasComparisonValue = (value) => (
  value !== undefined && value !== null && value !== '' && value !== '-' && value !== 'Indisponível'
);

export const shouldShowPercentage = (estimated, executed, executedRawValue) => {
  if (!hasComparisonValue(estimated) || !hasComparisonValue(executed)) return false;

  if (executedRawValue !== undefined && executedRawValue !== null) {
    // fancyTimeFormat omite frações de segundo: 0,9 s é mostrado como 0:00:00.
    return Number(executedRawValue) >= 1;
  }

  return isNaN(executed) || Number(executed) > 0;
};
